// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarIngreso_main__NmmVc","intro":"ModalEditarIngreso_intro__bHei4","input":"ModalEditarIngreso_input__1cqRT"};